export default {
    MAPBOX_TOKEN: "pk.eyJ1IjoicXVhczk0IiwiYSI6ImNpeGxhMDF1NjAwNTYzM2xlb3lvZWdqNzQifQ.QCA47aA-oj0Rl146PPHoBQ",
    GOOGLE_MAPS_KEY: 'AIzaSyB5eHRnOklYSAETSxnhM64Ld_IkovMZNFg',
    SOCKET_SERVER: 'wss://2gzfb83nj6.execute-api.us-east-1.amazonaws.com',
}